/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Bucket_30_60Inputs */

const vi_report_debt_bucket_30_60 = /** @type {(inputs: Report_Debt_Bucket_30_60Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 - 60 ngày`)
};

/**

* @param {Report_Debt_Bucket_30_60Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_bucket_30_60 = /** @type {((inputs?: Report_Debt_Bucket_30_60Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Bucket_30_60Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_bucket_30_60(inputs)
});